import { useQuery } from "@tanstack/react-query";

import { useApiTokenLazyQuery } from "@/generated/graphql";

interface TokenInput {
  assessmentId: string;
  workId: string;
}

/**
 * Query Pantheon for the API JWT Token needed to communicate with the Hermes
 * API.
 */
export function useHermesApiToken(input: TokenInput): string | null {
  const [getApiToken] = useApiTokenLazyQuery();
  const { data } = useQuery({
    queryKey: ["apiToken", input.assessmentId, input.workId],
    staleTime: 82800000, // 23 hours
    queryFn: async () => {
      const { data } = await getApiToken({ variables: input });
      return data?.apiToken ?? null;
    },
  });
  return data ?? null;
}
